import { useEffect } from 'react';
import sharedStyles from 'styles/css/SharedStyles.module.scss';
import formStyles from 'styles/css/FormStyles.module.scss';
import ShortHeaderWithBackBtn from 'components/root/partials/header/ShortHeaderWithBackBtn';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleChangeDataPagesVisitRequest } from "reduxx/actions/pages/user/visitReq";
import { handleSetOpenCustomSnackbar } from 'reduxx/actions/snackbar';
import { VISIT_REQUEST, CHECK_DISCOUNT_CODE } from 'apis';
import apiRequest from 'utils/apiRequest';
import Swal from 'sweetalert2';
import Logo512 from 'styles/images/logo/logo512.png';
import actionStyles from 'styles/css/ActionStyles.module.scss';

const VisitRequest = () => {

	const dispatch = useDispatch();
	const navigate = useNavigate();

    const { token, profile } = useSelector(state => state.login);
    const { doctorType, description, discountCode, activeDiscount, discountAmount, visitPrice, visitPriceAfterDiscount } = useSelector(state => state.visitReq);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);


    const handleDoctorType = (type) => {
    	dispatch(handleChangeDataPagesVisitRequest('doctorType', type));
        let price = "0";
        if(type === 1)
            price = '357,000';
        else if(type === 2)
            price = '498,000';
        else if(type === 3)
            price = '595,000';
        else if(type === 4)
            price = "1,000,000";
        else if(type === 5)
            price = "750,000";
        else if(type === 6)
            price = "500,000";
        else if(type === 7)
            price = "500,000";
        else if(type === 8)
            price = "500,000";
        // dispatch(handleChangeDataPagesVisitRequest('visitPrice', type === 1 ? '357,000' : (type === 2 ? '498,000' : '595,000')));
        dispatch(handleChangeDataPagesVisitRequest('visitPrice', price));
    };


    useEffect(() => {
        if (!visitPrice) return;

        if (discountAmount === '') {
            dispatch(handleChangeDataPagesVisitRequest(
                'visitPriceAfterDiscount',
                visitPrice
            ));
            return;
        }

        const visitPriceInt = parseInt(visitPrice.replace(',', ''));
        const hasPercent = discountAmount.includes('%');

        let newVisitPrice = 0;

        if (hasPercent) {
            const percent = parseFloat(discountAmount.replace('%', ''));
            newVisitPrice = Math.round(
                visitPriceInt * (100 - percent) / 100
            );
        } else {
            newVisitPrice = visitPriceInt - (parseInt(discountAmount) / 10);
        }

        dispatch(handleChangeDataPagesVisitRequest(
            'visitPriceAfterDiscount',
            newVisitPrice.toLocaleString()
        ));

    }, [visitPrice, discountAmount, dispatch]);


    const handelChangeInputs = (event) => {
        const {name, value} = event.target;

        dispatch(handleChangeDataPagesVisitRequest(name, value));
    };

    const handleSubmitForm = () => {
    	if(description.trim().length === 0)
    		dispatch(handleSetOpenCustomSnackbar(true, {message: 'لطفا شرح مختصری از وضعیت خود بنویسید', severity: 'error', vertical: 'top', horizontal: 'right'}));
    	else {
    		apiRequest({
                dispatch,
                endpoint: VISIT_REQUEST,
                method: 'post',
                data: { doctorType, description, discountCode },
                token: token,
                // successMessage: 'درخواست شما با موفقیت ثبت شد',
                onSuccess: (res) => {
                	dispatch(handleChangeDataPagesVisitRequest('doctorType', 1));
                	dispatch(handleChangeDataPagesVisitRequest('description', ''));
                    dispatch(handleChangeDataPagesVisitRequest('activeDiscount', false));
                    dispatch(handleChangeDataPagesVisitRequest('discountCode', ''));
                    dispatch(handleChangeDataPagesVisitRequest('discountAmount', ''));


                    // if(profile.medicalRecords.hasSpecialDisease === null)
                    //     navigate('/medical-record');
                    // else if(profile.medicalRecords.hasSpecialMedication === null)
                    //     navigate('/medical-record2');
                    // else if(profile.medicalRecords.hasDrugAllergy === null)
                    //     navigate('/medical-record3');
                    // else if(profile.medicalRecords.insurance === null || profile.nationalCode === null)
                    //     navigate('/medical-record4');
                    // else
                        // navigate(`success`);

                    window.open(res.payLink + `&token=${token}`, "_self");
                }
            });
    	}
    };


    const handleSubmitDiscountCode = () => {
        if(isBackdropLoading) return;

        if(!activeDiscount) {
            apiRequest({
                dispatch,
                endpoint: CHECK_DISCOUNT_CODE,
                method: 'post',
                data: { code: discountCode },
                token: token,
                // successMessage: 'درخواست شما با موفقیت ثبت شد',
                onSuccess: (res) => {
                    dispatch(handleChangeDataPagesVisitRequest('discountAmount', res.amount));
                    dispatch(handleChangeDataPagesVisitRequest('activeDiscount', true));


                    const buttonsOkCancel = Swal.mixin({
                        customClass: {
                            // confirmButton: actionStyles['btn-accept'],
                            confirmButton: [actionStyles['btn-cancel'], ].join(' '),
                            cancelButton: [actionStyles['btn-cancel'], actionStyles['mr-12']].join(' '),
                        },
                        buttonsStyling: false
                    });

                    buttonsOkCancel.fire({
                        text: `تخفیف با موقیت اعمال شد`,
                        imageUrl: Logo512,
                        imageHeight: 80,
                        imageAlt: 'logo',
                        confirmButtonText: "باشه",
                        showCancelButton: false,
                    }).then((result) => {
                        
                    }); 
                }
            });
        } else {
            dispatch(handleChangeDataPagesVisitRequest('activeDiscount', false));
            dispatch(handleChangeDataPagesVisitRequest('discountCode', ''));
            dispatch(handleChangeDataPagesVisitRequest('discountAmount', ''));
        }
    };


    const toPersianDigits = (num) => {
        return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
    };

    return (
        
        <div className={sharedStyles.container}>

        	<div className={[sharedStyles['container-padding'], sharedStyles['pb-24']].join(' ')}>
        		<ShortHeaderWithBackBtn />
        		
	            <div className={formStyles.title}>نوع پزشک مورد نظر جهت مشاوره را انتخاب فرمایید</div>
				<div className={formStyles.priceOptions}>
					<button onClick={() => handleDoctorType(1)} className={`${formStyles.priceButton} ${doctorType === 1 ? formStyles.active : ''}`}>پزشک عمومی <br /> {toPersianDigits("357,000")} ت</button>
					<button onClick={() => handleDoctorType(2)} className={`${formStyles.priceButton} ${doctorType === 2 ? formStyles.active : ''}`}>متخصص <br /> {toPersianDigits("498,000")} ت</button>
					<button onClick={() => handleDoctorType(3)} className={`${formStyles.priceButton} ${doctorType === 3 ? formStyles.active : ''}`}>فوق تخصص <br /> {toPersianDigits("595,000")} ت</button>

                    <button onClick={() => handleDoctorType(4)} className={`${formStyles.priceButton} ${doctorType === 4 ? formStyles.active : ''}`}>مشاوره اعمال جراحی <br /> {toPersianDigits("1,000,000")} ت</button>
                    <button onClick={() => handleDoctorType(5)} className={`${formStyles.priceButton} ${doctorType === 5 ? formStyles.active : ''}`}>مشاوره ژنتیک <br /> {toPersianDigits("750,000")} ت</button>
                    <button onClick={() => handleDoctorType(6)} className={`${formStyles.priceButton} ${doctorType === 6 ? formStyles.active : ''}`}>مشاوره تغذیه  <br /> {toPersianDigits("500,000")} ت</button>
                    <button onClick={() => handleDoctorType(7)} className={`${formStyles.priceButton} ${doctorType === 7 ? formStyles.active : ''}`}>مشاوره روانشناسی   <br /> {toPersianDigits("500,000")} ت</button>
                    <button onClick={() => handleDoctorType(8)} className={`${formStyles.priceButton} ${doctorType === 8 ? formStyles.active : ''}`}>مشاوره پوست، مو و زیبایی <br /> {toPersianDigits("500,000")} ت</button>
				</div>
				<div className={formStyles.title}>شرح مختصری از درخواست خود را برای پزشک بنویسید:</div>
				<textarea name="description" value={description} onChange={handelChangeInputs} className={formStyles.descriptionBox} placeholder="..." />

                <div className={[sharedStyles.flex, sharedStyles['flex-col']].join(' ')} style={{marginBottom: '8px'}}>
                    <span className={formStyles.title}>
                        اگر کد تخفیف دارید وارد کنید
                    </span>
                    <div className={[sharedStyles.flex, sharedStyles['cat-box'], sharedStyles['radius-normal']].join(' ')} style={{paddingRight: '14px', marginTop: '8px'}}>
                        <input 
                                value={discountCode}
                                onChange={handelChangeInputs}
                                name="discountCode"
                                type="text" 
                                placeholder="کد تخفیف" 
                                className={[sharedStyles['radius-normal'], sharedStyles['border-none'], sharedStyles['flex-1']].join(' ')} />
                        <button onClick={handleSubmitDiscountCode} className={[!activeDiscount ? sharedStyles['item-active'] : sharedStyles['item-deactive'], sharedStyles['radius-normal'], sharedStyles['border-none'], sharedStyles['px-lg'], sharedStyles['py-lg']].join(' ')}>
                            { !activeDiscount ?
                                <span>اعمال کد تخفیف</span>
                                :
                                <span>لغو تخفیف</span>
                            }
                        </button>
                    </div>
                </div>

				<button onClick={handleSubmitForm} className={formStyles.button}>پرداخت {toPersianDigits(visitPriceAfterDiscount)} تومان و ثبت درخواست</button>
				<div className={formStyles.note}>
					• تعرفه ویزیت، براساس تعرفه آزاد (طبق مصوبه هیأت محترم دولت در سال {toPersianDigits("1405")}) می‌باشد، ولی متقاضی دریافت کننده خدمت (بیمار)، هنگام مراجعه به داروخانه و یا مراکز پاراکلینیک (آزمایشگاه، مراکز تصویربرداری و سونوگرافی، مراکز فیزیوتراپی و ... ) میتواند از حق  بیمه‌ی خود (بصورت کامل طبق قوانین بیمه) استفاده کند.
				</div>
                <div className={formStyles.note}>
                    • پس از پرداخت و ثبت موفق درخواست، پزشکان نخبه دکتر بیست (Dr20) در اسرع وقت با شما تماس خواهند گرفت.
                </div>
                <div className={formStyles.note}>
                    {/*• در صورت نیاز میتوانید با پشتیبانی دکتر بیست به شماره <a href="https://wa.me/+989020843320" className={formStyles['link-normal']}>09020843320</a> از طریق  واتس‌اپ  ارتباط برقرار کنید.*/}
                    • در صورت نیاز میتوانید با پشتیبانی دکتر بیست به شماره <a href="https://rubika.ir/dr20_org" className={formStyles['link-normal']}>09020843320</a> از طریق  روبیکا  ارتباط برقرار کنید.
                </div>
        	</div>

		</div>

    );
}

export default VisitRequest;